<template>
    <div class="salas-view container-fluid mt-4">
      <!-- Botonera superior -->
      <div class="button-bar mb-3 d-flex justify-content-center gap-3">
        <button
          class="btn btn-outline-primary"
          :class="{ active: activeComponent === 'ListarPlantasSala' }"
          @click="setActiveComponent('ListarPlantasSala')"
        >
          <font-awesome-icon icon="fas fa-seedling" class="me-1" />
          Plantas de la Sala
        </button>
        <button
          class="btn btn-outline-primary"
          :class="{ active: activeComponent === 'MoverPlantasSalas' }"
          @click="setActiveComponent('MoverPlantasSalas')"
        >
          <font-awesome-icon icon="fas fa-exchange-alt" class="me-1" />
          Mover Plantas a Salas
        </button>
      </div>
      <!-- Área dinámica de componentes -->
      <div class="component-container">
        <component :is="activeComponent" :proyecto_id="proyecto_id" />
      </div>
    </div>
  </template>
  
  <script>
  import ListarPlantasSala from '@/components/SalaPlanta/listarSalaPlanta.vue';
  import MoverPlantasSalas from '@/components/SalaPlanta/salaPlantaGestion.vue';
  import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
  
  export default {
    name: 'salaGestion',
    components: {
        ListarPlantasSala,
      MoverPlantasSalas,
      FontAwesomeIcon,
    },
    props: {
      proyecto_id: {
        type: Number,
        required: true,
      },
    },
    data() {
      return {
        activeComponent: 'ListarPlantasSala', // Componente activo por defecto
      };
    },
    methods: {
      setActiveComponent(componentName) {
        this.activeComponent = componentName;
      },
    },
  };
  </script>
  
  <style scoped>
  .salas-view {
    padding: 20px;
    background-color: #f7f8fa;
    font-family: 'Roboto', sans-serif;
  }
  .button-bar {
    display: flex;
    justify-content: center;
    gap: 1rem;
    flex-wrap: wrap;
  }
  .button-bar .btn {
    font-size: 1.1rem;
    padding: 10px 20px;
    transition: background-color 0.3s ease, box-shadow 0.3s ease;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
  .button-bar .btn.active,
  .button-bar .btn:hover {
    background-color: var(--app-primary);
    color: #fff;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  }
  .component-container {
    margin-top: 20px;
  }
  </style>
  